import React, {
  useState,
  useContext,
  forwardRef,
  useImperativeHandle,
} from "react";
import { LayoutContext, constants } from "./LayoutContext";
import { TopbarLanguageIcons } from "./TopbarLanguageIcons";
import IconGlobe from "../assets/dazzle-globe.svg";

export const TopbarLanguage = forwardRef((props, ref) => {
  const { i18n, pagePath } = props;
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(
    ref,
    () => {
      return {
        closeIcons() {
          setIsOpen(false);
        },
      };
    },
    []
  );

  const layoutContext = useContext(LayoutContext);
  const { theme } = layoutContext;

  return (
    <div
      className={
        theme === constants.THEME_LIGHT
          ? "topbar-icon theme-light"
          : "topbar-icon theme-dark"
      }
      id="topbar-language-icon"
    >
      <span
        className="i18n-icon-wrapper"
        onClick={e => {
          setIsOpen(!isOpen);
          e.stopPropagation();
        }}
      >
        <IconGlobe className="topbar-svg-icon" />
      </span>
      {isOpen && <TopbarLanguageIcons i18n={i18n} pagePath={pagePath} />}
    </div>
  );
});
